import Instance from '../../../../Axios';

// New Actions for the app

const DeleteDocumentoOficial = (id) => async (dispatch) => {
  await Instance()
    .put(`/energias/docsOficiais/${id}`)
    .then(({ data }) => {
    //   console.log(data);
      dispatch({ type: 'DELETE_DOCUMENTO_OFICIAL', payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default DeleteDocumentoOficial;